import { Flex } from 'antd';
import styled from 'styled-components';

export const StepTitle = styled.span`
  font-weight: 500;
`;

export const Container = styled(Flex).attrs({ vertical: true, gap: 16 })`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding: 0 24px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: ${(props) => props.theme.antd?.colorPrimary};
`;

export const SectionBlackTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 500;
  color: #334423;
  span {
    margin-left: 8px;
    color: ${(props) => props.theme.antd?.colorPrimary};
  }
`;

export const Section = styled.section`
  padding: 24px;
  background: #fff;
`;

export const Hint = styled.p`
  margin: 0;
  margin-bottom: 8px;
  color: ${(props) => props.theme.antd?.colorTextHeading};
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`;
